/**
 * Stable deferred loaders for LazyHydrate.
 * Server: sync require (SSR HTML preserved).
 * Client: dynamic import (separate webpack chunks).
 */

export const loadCategoryListSection = () =>
    typeof window === 'undefined'
        ? { default: require('./sections/CategoryListSection').default }
        : import(/* webpackChunkName: "home-category-list" */ './sections/CategoryListSection');

export const loadBrandCarouselSection = () =>
    typeof window === 'undefined'
        ? { default: require('./sections/BrandCarouselSection').default }
        : import(/* webpackChunkName: "home-brand-carousel" */ './sections/BrandCarouselSection');

export const loadReasonsSection = () =>
    typeof window === 'undefined'
        ? { default: require('./sections/ReasonsSection').default }
        : import(/* webpackChunkName: "home-reasons" */ './sections/ReasonsSection');

export const loadTrustedSection = () =>
    typeof window === 'undefined'
        ? { default: require('./sections/TrustedSection').default }
        : import(/* webpackChunkName: "home-trusted" */ './sections/TrustedSection');

export const loadInfoSection = () =>
    typeof window === 'undefined'
        ? { default: require('./sections/InfoSection').default }
        : import(/* webpackChunkName: "home-info" */ './sections/InfoSection');
